import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

import { AI_COLORS } from '../aiAnalyticsConstants';

export default function SaveChartDialog({ open, title, saving, onTitleChange, onCancel, onSave }) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Save Chart</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="Chart Title"
          value={title}
          onChange={e => onTitleChange(e.target.value)}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={saving}>
          Cancel
        </Button>
        <Button
          onClick={onSave}
          variant="contained"
          disabled={saving || !title.trim()}
          sx={{ backgroundColor: AI_COLORS.brand, '&:hover': { backgroundColor: AI_COLORS.brandDark } }}
        >
          {saving ? 'Saving…' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
